var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 456",
    transform: "translate(-164 -602)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\u6955\\u5186\\u5F62 2",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(164 602)",
    fill: "rgba(255,255,255,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u591A\\u89D2\\u5F62 4",
    d: "M189.5 619.5l-12 8.274v-16.548z",
    fill: "#515151"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonIcon);
export default __webpack_public_path__ + "static/media/playButtonIcon.7dfa1c1810086716.svg";
export { ForwardRef as ReactComponent };